import { render, staticRenderFns } from "./ShipStatusWidget.vue?vue&type=template&id=38477c2e&scoped=true"
import script from "./ShipStatusWidget.vue?vue&type=script&lang=js"
export * from "./ShipStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipStatusWidget.vue?vue&type=style&index=0&id=38477c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38477c2e",
  null
  
)

export default component.exports